import { IOffer } from '../../../types/offer';
import { numberToPrettyString } from '@cian/utils';
import { getCurrencySign } from './getCurrencySign';

export function getAgentBonusPrice(offer: IOffer, isAgent: boolean): string | undefined {
  const { agentBonus } = offer.bargainTerms;

  if (isAgent && agentBonus) {
    let bonus = numberToPrettyString(agentBonus.value);

    if (agentBonus.paymentType === 'percent') {
      bonus += '%';

      return `Бонус агенту ${bonus}`;
    }

    if (agentBonus.currency === 'rur') {
      bonus += `\u00A0${getCurrencySign(agentBonus.currency)}`;
    } else {
      bonus = `${getCurrencySign(agentBonus.currency || '')}${bonus}`;
    }

    return `Бонус агенту ${bonus}`;
  }

  return undefined;
}
